import {API} from "@/api/generated";
import {QuizListItem} from "@/page/quiz/typeQuiz";
import {router} from "@/router";
import {useQuizStore} from "@/stores/quizData";

type SetQuizResult = Awaited<ReturnType<typeof API.setQuiz>>;
type QuizConflictResponse = Extract<SetQuizResult, {response: string}>;

export const isQuizConflictResponse = (
  result: SetQuizResult
): result is QuizConflictResponse => "response" in result;

export async function createQuiz(): Promise<void> {
  const quizStore = useQuizStore();
  const quizList = quizStore.getQuizList;

  const name = getUniqueQuizName("Новый квиз", quizList);

  const res = await API.setQuiz({
    body: {
      name,
      questions: [
        {
          type: "contacts",
          question: "Контакты",
          contacts: {
            name: {bool: true},
            phone: {bool: true},
            email: {bool: false},
            connectionList: {bool: false},
            country: "Россия (+7)",
            headerMobile: {
              placeholder: ""
            },
            paragraphMobile: {
              placeholder: ""
            }
          },
          connection: [
            {bool: false, text: "Телефон"},
            {bool: false, text: "Whats App"},
            {bool: false, text: "Viber"},
            {bool: false, text: "Telegram"}
          ],
          placeholder: ""
        },
        {
          type: "ThankYouPages",
          question: "",
          placeholder: ""
        }
      ],
      isActionTopMobile: true,
      mobileVersionQuiz: {
        companyName: "",
        textContactButton: "Рассчитать",
        styleName: {
          type: "onlyName"
        },
        styleContacts: {
          type: "both"
        },
        header: "",
        paragraf: "",
        nextButton: "",
        actionList: [],
        actionHeader: "",
        rightSectionList: [],
        onlyFormBool: false
      },
      textContactButton: "",
      photoRight: [],
      actionList: [],
      rightSectionList: []
    }
  });

  if (isQuizConflictResponse(res)) {
    throw new Error(res.message);
  }

  quizStore.addQuiz(res);

  updateQuiz(res._id);
}

function getUniqueQuizName(
  baseName: string,
  list: QuizListItem[] | "await"
): string {
  if (list == "await") {
    return baseName;
  }
  let name = baseName;
  let counter = 1;

  // Проверяем, есть ли уже такое имя
  while (list.map((q) => q.name).includes(name)) {
    name = `${baseName} - ${counter}`;
    counter++;
  }

  return name;
}

function updateQuiz(id: string): void {
  localStorage.removeItem("ABTest");
  router.push("/quiz/setting/" + id + "/landingPage");
}
